import React, { Component } from 'react';
import './App.css';
import axios from 'axios';
import equals from 'object-equal';

let QUIZ_ENDPOINT
if (window.location.href.indexOf("localhost") > -1) {
  QUIZ_ENDPOINT = "http://localhost:8888/problems"
} else {
  QUIZ_ENDPOINT = "https://w8bql8pw5c.execute-api.us-east-1.amazonaws.com/prod/problems"
}
console.log("QUIZ_ENDPOINT %o", QUIZ_ENDPOINT)

class App extends Component {
  render() {
    return (
      <div className="App">
        <Quiz />
      </div>
    );
  }
}

class Quiz extends Component {
  constructor(props) {
    super(props);
    this.state = {problems: []};
  }

  // no need to transform any more but keeping the transform method around just
  // in case.
  transform(item) {
    let p = {};
    p["question"] = item["question"];
    p["choices"] = item["choices"];
    p["details"] = item["details"];
    return p;
  }

  componentDidMount() {
    let quiz = document.getElementById('quiz');
    let exam = quiz.getAttribute("data-exam");
    exam = escape(exam);
    let endpoint = `${QUIZ_ENDPOINT}?exam_name=${exam}`

    axios.get(endpoint)
      .then(res => {
        let quiz = res.data;
        var problems = quiz.map((item) => {
          return(this.transform(item));
        });
        this.setState({problems: problems});

        // var json = JSON.stringify(quiz, null, 2)
        // console.log("json:");
        // console.log(json);
        // console.log("load complete");

      });

  }
  render() {
    const problems = this.state.problems.map((problem) =>
      <Problem key={problem["question"]} problem={problem} />
    );
    return (
      <div className="Quiz">
        {problems}
      </div>
    )
  }
}

class Problem extends Component {
  constructor(props) {
    super(props)
    // Example state:
    // "state": {
    //   "answers": {
    //      "A": true,
    //      "B": false,
    //      "C": undefined
    //    },
    //    "correct": false,
    //    "showDetails": true
    // }
    this.state = {"answers": {}}
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);

    this.correctAnswers = props.problem["choices"]
                            .filter(choice => choice["correct"])
                            .map(choice => choice["key"])
                            .sort()
  }

  render() {
    return (
      <div className="Problem">
        <form onSubmit={this.handleSubmit}>
          <Question text={this.props.problem["question"]} />
          <Choices choices={this.props.problem["choices"]} toggleCheckbox={this.toggleCheckbox} />
          { this.state.showDetails ?
              <Details correct={this.state.correct} correctAnswers={this.correctAnswers} details={this.props.problem["details"]} /> :
              null }
          <input className="btn-info" type="submit" value="Submit" />
        </form>
      </div>
    )
  }

  toggleCheckbox(event) {
    let key = event.target["name"]
    let state = this.state
    state["answers"][key] = !state["answers"][key]
    this.setState(state)
  }

  handleSubmit(event) {
    var correct = this.checkAnswer()
    var state = this.state
    state["correct"] = correct
    state["showDetails"] = true
    this.setState(state)
    event.preventDefault();
  }

  checkAnswer() {
    // {"A": true, "B": false} => [["A", true], ["B", false]]
    let submitted_answers = Object.entries(this.state["answers"])
    submitted_answers = submitted_answers
                          .filter(a => a[1])
                          .map(a => a[0])
                          .sort()
    return equals(this.correctAnswers, submitted_answers)
  }

}

// choices structure:
// "choices": [
//   {
//     "key": "A",
//     "text": "Alyssa"
//   },
//   {
//     "correct": true,
//     "key": "B",
//     "text": "Karissa"
//   }
// ]
class Choices extends Component {
  render() {
    const choices = this.props.choices.map((choice) =>
      <label key={choice["key"]} className={choice["key"]} >
        <input
          name={choice["key"]}
          type="checkbox"
          checked={choice["checked"]}
          onChange={this.props.toggleCheckbox} />
        {choice["key"]}. {choice["text"]}
        <br />
      </label>
    );
    return (
      <div className="Choices">{choices}</div>
    )
  }

}

class Question extends Component {
  render() {
    return (
      <div className="Question">{this.props.text}</div>
    )
  }
}

class Details extends Component {
  render() {
    return (
      <div className="Details">
        {this.props.correct ?
          "Correct. " :
          "Incorrect. Correct answer: " + this.props.correctAnswers.join(', ') + '. '}
        {this.props.details ? this.props.details : ''}
      </div>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js